import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=91acff1a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=91acff1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91acff1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91acff1a')) {
      api.createRecord('91acff1a', component.options)
    } else {
      api.reload('91acff1a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=91acff1a&scoped=true&", function () {
      api.rerender('91acff1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AQ1ZkEFOiA1p/JS/comp/GuestBox.vue"
export default component.exports